import type { TelemetryVehicle } from './models';

/** How a reported vehicle is named, wherever it is listed. */
export const labelOf = (vehicle: TelemetryVehicle): string =>
  vehicle.licensePlateRaw || vehicle.licensePlate || vehicle.externalVehicleId;

/**
 * The name of whatever a reported vehicle is linked to, its truck or its trailer.
 *
 * A unit is linked to one of the two, never both, so one expression covers either link and every list that
 * shows a unit can say where it sits.
 */
export const linkedNameOf = (vehicle: TelemetryVehicle): string =>
  vehicle.supplierTruckName ?? vehicle.trailerName ?? vehicle.trailerLicensePlate ?? vehicle.licensePlate;
